import React, { Component } from 'react';
import './ProgressBullets.css';

class ProgressBullets extends Component {
  render() {
    return  <div className="sn_progress_bullets">
              
              <div className={'sn_progress_bullets_step' + (this.props.step === '1' ? " _active" : '')}>            
              </div>
            
              <div className={'sn_progress_bullets_step' + (this.props.step === '2' ? " _active" : '')}>
              </div>

              <div className={'sn_progress_bullets_step' + (this.props.step === '3' ? " _active" : '')}>
              </div>
            
              <div className={'sn_progress_bullets_step' + (this.props.step === '4' ? " _active" : '')}>
              </div>
                 
            </div>;
  }
}

export default ProgressBullets;


// WEBPACK FOOTER //
// ./src/assets/components/progressBullets/ProgressBullets.js